import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { getRingtoneUrl } from 'flow/utils/ringtone-utils';
import {
    fetchRingtonesList,
    setRingtoneSettings,
} from 'flow/actions/ringtone-actions';

import { useHistory, useParams } from 'react-router-dom';
import Page from 'flow/components/Setting/Page';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import RadioButton from 'flow/components/ui-components/RadioButton';
import { MiniAudioPlayer } from 'flow/components/AudioPlayers';
import Loading from 'flow/components/ui-components/Loading';
import { generatePath } from 'flow/utils/router-utils';

const SelectRingtone = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();

    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const ringtonesList = useAppSelector((state) => state.ringtones.get('all'));

    const selected = useAppSelector((state) =>
        state.ringtones.getIn(['settings', 'key']),
    );

    useEffect(() => {
        dispatch(fetchRingtonesList());
    }, []);

    if (!ringtonesList) {
        return <Loading />;
    }

    return (
        <Page
            header={'media.settings.ringtone'}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.softphone.ringtone'], {
                        extensionKey,
                    }),
                )
            }
        >
            {ringtonesList.map((ringtone) => (
                <div
                    className="rounded-sm px-2 hover:bg-gray-100"
                    key={ringtone.get('key')}
                >
                    <div className="my-1 flex items-center justify-between">
                        <RadioButton
                            name={ringtone?.get('key')}
                            checked={selected === ringtone?.get('key')}
                            onChange={() =>
                                dispatch(
                                    setRingtoneSettings(ringtone?.get('key')),
                                )
                            }
                        >
                            {ringtone.get('name')}
                        </RadioButton>

                        <div className="ms-auto">
                            {getRingtoneUrl(ringtone?.get('key')) ? (
                                <MiniAudioPlayer
                                    url={getRingtoneUrl(ringtone?.get('key'))}
                                    uniqueId={ringtone?.get('key')}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            ))}
        </Page>
    );
};

export default SelectRingtone;
